import React from 'react';
import { startCase } from 'lodash';

import FormGroup from '~/commons/components/FormGroup.jsx';
import { env } from '~/commons/config';

export default function FieldBasic() {
  return (
    <>
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">BASIC</h6>
      <div className="row">
        <div className="col">
          <FormGroup name="itemCode" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="serialNo" />
        </div>
        <div className="col">
          <FormGroup name="cloudIOOrder" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="status" as="select">
            <option value=""> - </option>
            {(env?.status?.stocks || []).map((v) => (
              <option value={v} key={v}>
                {startCase(v)}
              </option>
            ))}
          </FormGroup>
        </div>
        <div className="col">
          <FormGroup name="orgId" label="Organization ID (Comma separated)" />
        </div>
      </div>
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">ADDITIONAL</h6>
      <div className="row">
        <div className="col">
          <FormGroup name="design.design" label="Design" as="display" />
        </div>
        <div className="col">
          <FormGroup name="category" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="yarnContent" label="Color / Content (Comma separated)" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="remarks" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="internalRemarks" as="textarea" style={{ height: '100px' }} />
        </div>
      </div>
      <FormGroup
        name="photos"
        as="slider"
        api="/api/core/stocks/files"
        label="Photos"
        gridClassName="col-3 my-3"
        slideClassName="file-slide-contain square"
      />
    </>
  );
}
